import QuickBooks from 'src/assets/images/QuickBooks.svg'
import NetSuite from 'src/assets/svgs/NetSuiteIcon.svg'
import {
  OrganizationConnectedPlatform,
  OrganizationIntegrationStatus,
} from 'src/enums'
import {
  BankAccountListModel,
  BankAccountListResponse,
} from 'src/models/bankAccount.models'

export interface OrganizationIntegrationListResponse {
  id: string
  organizationId: string
  connectionIntentId: string
  connectionToken: string
  companyToken: string
  connectionStatus: OrganizationIntegrationStatus
  connectedPlatform: OrganizationConnectedPlatform
  bankAccount?: BankAccountListResponse
  bankAccountOptions?: BankAccountListResponse[]
  lastSyncDate?: string
}

export class OrganizationIntegrationListModel {
  public id: string
  public organizationId: string
  public connectionIntentId: string
  public connectionToken: string
  public companyToken: string
  public connectionStatus: OrganizationIntegrationStatus
  public connectedPlatform: OrganizationConnectedPlatform
  public bankAccount?: BankAccountListModel
  public bankAccountOptions?: BankAccountListModel[]
  public lastSyncDate?: string

  public constructor(data: OrganizationIntegrationListResponse) {
    this.id = data.id
    this.connectionIntentId = data.connectionIntentId
    this.organizationId = data.organizationId
    this.connectionToken = data.connectionToken
    this.companyToken = data.companyToken
    this.connectionStatus = data.connectionStatus
    this.connectedPlatform = data.connectedPlatform
    if (data.bankAccount) {
      this.bankAccount = new BankAccountListModel(data.bankAccount)
    }
    if (data.bankAccountOptions) {
      this.bankAccountOptions = data.bankAccountOptions.map(
        (option) => new BankAccountListModel(option),
      )
    }
    this.lastSyncDate = data.lastSyncDate
  }

  public get logo(): string {
    switch (this.connectedPlatform) {
      case OrganizationConnectedPlatform.NETSUITE:
        return NetSuite
      case OrganizationConnectedPlatform.QUICKBOOKS_ONLINE_SANDBOX:
      case OrganizationConnectedPlatform.QUICKBOOKS_DESKTOP:
      case OrganizationConnectedPlatform.QUICKBOOKS_ONLINE:
        return QuickBooks
      default:
        return ''
    }
  }

  public get platformName(): string {
    switch (this.connectedPlatform) {
      case OrganizationConnectedPlatform.NETSUITE:
        return 'NetSuite'
      case OrganizationConnectedPlatform.QUICKBOOKS_ONLINE_SANDBOX:
      case OrganizationConnectedPlatform.QUICKBOOKS_ONLINE:
        return 'QuickBooks'
      case OrganizationConnectedPlatform.QUICKBOOKS_DESKTOP:
        return 'QuickBooks Desktop'
      default:
        return ''
    }
  }

  public get connectionMessage(): string {
    switch (this.connectedPlatform) {
      case OrganizationConnectedPlatform.NETSUITE:
        return 'Connect your NetSuite account to ${appName} so you can tag your transactions with NetSuite tracking categories and push to NetSuite when desired.'
      case OrganizationConnectedPlatform.QUICKBOOKS_ONLINE_SANDBOX:
      case OrganizationConnectedPlatform.QUICKBOOKS_DESKTOP:
      case OrganizationConnectedPlatform.QUICKBOOKS_ONLINE:
        return 'Connect your QuickBooks account to ${appName} so you can tag your transactions with QuickBooks tracking classes and locations, then push to QuickBooks when desired.'
      default:
        return ''
    }
  }
}
